import { Component, ChangeDetectionStrategy, signal, viewChild } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { StockErrorItem } from '../stock-error-views';

@Component({
    selector: 'pxw-stock-errors-dialog',
    templateUrl: './stock-errors-dialog.component.html',
    styleUrls: ['./stock-errors-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent]
})
export class StockErrorsDialogComponent {
  readonly modalDialog = viewChild.required(ModalDialogComponent);

  readonly stockErrors = signal<StockErrorItem[]>([]);

  open(stockErrors: StockErrorItem[]) {
    this.stockErrors.set(stockErrors);

    return this.modalDialog().open().catch(() => {});
  }
}
